import React from 'react';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import RouterChangeTracker from '../services/RouterChangeTracker';
import Navbar from './Navbar';
import SiljukBanner from './SiljukBanner';

export default function Root() {
     RouterChangeTracker();
     return (
          <main className="flex flex-col w-screen h-screen bg-bg">
               <Navbar />

               <div className="w-full h-full overflow-y-auto relative flex flex-col pt-4">
                    <div className="px-4 md:px-10">
                         <SiljukBanner />
                         <hr className="my-4 border-gray-200" />
                    </div>
                    <div className="flex-1 pb-10 px-0 md:px-0">
                         <Outlet />
                    </div>
                    
                    <div className="z-0 flex flex-col px-6 py-4 text-xs italic text-slate-500 md:flex-row justify-end text-right mt-auto">
                         <div className="space-y-1">
                              <p>
                                   ✓ 본 사이트는 PC에 최적화되어 있습니다. 각 행을
                                   클릭하시면 해당 기업의 관련 차트가 그려지게
                                   됩니다.
                              </p>
                              <p>
                                   ✓ 문의사항이나 개선사항이 있으시면
                                   stockinu.com@gmail.com 으로 연락주세요.
                              </p>
                         </div>
                    </div>
               </div>
          </main>
     );
}
